import React from 'react';
import "./HowTo.scss";
import Image1 from "../../assets/images/1.svg";
import Image2 from "../../assets/images/2.svg";
import Image3 from "../../assets/images/3.svg";
import { TitleSecondary } from '..';

const HowTo = () => {
    return (
        <div className="how-to">
            <TitleSecondary>¿Cómo funciona Solucionarte?</TitleSecondary>
            <h3 className="how-to__title">Es muy simple</h3>
            {/* <h3>Seguí los siguientes pasos...</h3> */}

            <div className="how-to__steps">
                <div className="how-to__step">
                    <div className="how-to__steps-container-image">
                        <img src={Image1} alt="" />
                    </div>
                    <h4>Busca un prestador</h4>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id pariatur quos molestias veritatis, consequatur totam sint exercitationem obcaecati fugit error!</p>
                </div>
                <div className="how-to__step">
                    <div className="how-to__steps-container-image">
                        <img src={Image2} alt="" />
                    </div>
                    <h4>Contactalo</h4>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id pariatur quos molestias veritatis, consequatur totam sint exercitationem obcaecati fugit error!</p>
                </div>
                <div className="how-to__step">
                    <div className="how-to__steps-container-image">
                        <img src={Image3} alt="" />
                    </div>
                    <h4>¡Listo!</h4>
                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Id pariatur quos molestias veritatis, consequatur totam sint exercitationem obcaecati fugit error!</p>
                </div>
            </div>
        </div>
    )
}

export default HowTo;
